import { QuestionBase } from './question-base';

/*

Sample:

new Decorator({
  class: 'col s12',
  iconClass: 'glicon-plus blue-text'
}),


*/
export class Decorator extends QuestionBase<any> {
  controlType = 'decorator';
  html: string;
  wysiwyg: string;
  iconClass: string;
  labelClass: string;
  valueClass: string;
  buttonType: string;
  isDefaultClass: boolean;
  isTranslationModal: boolean;
  kpisQuestions: any;
  kpisTranslatedQuestions: any;
  languageQuestion: any;
  languageTranslatedQuestion: any;
  constructor(options: any = {}) {
    super({ ...options, hideLabel: true });
    const {
      html,
      wysiwyg,
      iconClass,
      labelClass,
      valueClass,
      buttonType,
      isDefaultClass = true,
      isTranslationModal,
      kpisQuestions,
      kpisTranslatedQuestions,
      languageQuestion,
      languageTranslatedQuestion
    } = options;
    this.html = html;
    this.wysiwyg = wysiwyg;
    this.iconClass = iconClass;
    this.labelClass = labelClass;
    this.valueClass = valueClass;
    this.buttonType = buttonType;
    this.isTranslationModal = isTranslationModal;
    this.isDefaultClass = isDefaultClass;
    this.kpisQuestions = kpisQuestions;
    this.kpisTranslatedQuestions = kpisTranslatedQuestions;
    this.languageQuestion = languageQuestion;
    this.languageTranslatedQuestion = languageTranslatedQuestion;
  }
}
